export function getPageTitle(pathname: string): string {
  if (pathname === '/' || pathname === '') return 'Home';
  if (pathname.startsWith('/catalog/default/group/')) return 'Team';
  if (/^\/catalog\/[^/]+\/component\/[^/]+\/census\/?$/.test(pathname))
    return 'Census card';
  if (pathname.startsWith('/catalog')) return 'Software Catalog';
  if (pathname.startsWith('/api-docs')) return 'APIs';
  if (pathname.startsWith('/docs')) return 'Documentation';
  if (pathname.startsWith('/aoe-radar')) return 'Arrive Tech Radar';
  if (pathname.startsWith('/analytics')) return 'Analytics';
  if (pathname.startsWith('/ai-marketplace')) return 'AI Marketplace';
  if (pathname.startsWith('/architecture')) return 'Architecture';
  if (pathname.startsWith('/security-insights')) return 'Security Single View';
  if (pathname.startsWith('/preview')) return 'Preview';
  if (pathname.startsWith('/fleet-census')) return 'Fleet Census';
  if (pathname.startsWith('/tech-summary')) return 'Tech Summary';
  if (pathname.startsWith('/scorecard-leaderboard'))
    return 'Scorecard Leaderboard';
  if (pathname.startsWith('/code-migrations')) return 'Modernisation Tracker';
  if (pathname.startsWith('/arrive-agent-launch-platform'))
    return 'Agent Launch Platform';
  if (pathname.startsWith('/external-down-detector'))
    return 'External Down Detector';
  if (pathname.startsWith('/finops')) return 'FinOps';
  if (pathname.startsWith('/mcp-chat')) return 'MCP Chat';
  if (pathname.startsWith('/settings')) return 'Settings';
  if (pathname.startsWith('/search')) return 'Search';
  return 'Backstage';
}
